import { UserFieldErrorMessages } from "@constants/Errors";
import { handleNumericalCheck } from "@services/ErrorHandling";
import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { handleGenericCheck } from "../../../../services/ErrorHandling";

type UserDepartmentPositionCardProps = {
  departmentName: string;
  positionName: string;
  errors: any;
  updateTenantDepartmentData: (field: string, value: any) => void;
  updateError: (field: string, value: any) => void;
  handleDepartmentClick: () => void;
};

export const UserDepartmentPositionCard = ({
  departmentName,
  positionName,
  errors,
  updateTenantDepartmentData,
  updateError,
  handleDepartmentClick,
}: UserDepartmentPositionCardProps) => (
  <div>
    <div className="w-full md:w-3/5">
      <div className="flex items-center gap-4">
        <input
          type="text"
          className="form-field-text whitespace-nowrap flex-1"
          value={departmentName || "未登録"}
          readOnly
        />
        <div className="button-default-white" onClick={handleDepartmentClick}>
          部署選択
        </div>
      </div>
    </div>

    <div className="mt-5 divider"></div>

    <div className="w-full md:w-3/5">
      <div>
        <div className="flex-1">
          <TextInputField
            type="text"
            label={"役職"}
            providedClassName="form-text-field-border-full"
            value={positionName}
            placeholder="未登録"
            onChange={(e) =>
              handleGenericCheck(
                "position_name",
                e.target.value,
                updateTenantDepartmentData,
                updateError,
                32,
              )
            }
          />
          {errors.position_name && (
            <p className="text-red-500">
              {UserFieldErrorMessages.positionError}
            </p>
          )}
        </div>
      </div>
    </div>
    <div className="mt-5 divider"></div>
  </div>
);
